<div class="animate-fade-in">
    <app-data-table title="Personal del Negocio"
        description="Gestiona los accesos y acciones permitidas para tu equipo de trabajo"
        icon="solar:users-group-rounded-bold-duotone" [total]="total()" [dataSource]="displayStaff()"
        [columns]="columns" [pagination]="pagination()" (onSearch)="handleSearch($event)"
        (onReload)="staffResource.reload()" [loading]="loading()" (onPageChange)="handlePageChange($event)"
        (onLimitChange)="handleLimitChange($event)" [columnTemplates]="{
            'fullName': userTmpl,
            'email': emailTmpl,
            'status': statusTmpl
        }">

        <!-- Metrics Slot -->
        <ng-template #metrics>
            <app-metrics [items]="metricsItems()"></app-metrics>
        </ng-template>

        <ng-template #actionGroup *appCanAccess="'staff:create'">
            <app-button variant="glass" size="md" [square]="true" [spinIconOnHover]="true" routerLink="/app/staff/new"
                title="Invitar Colaborador" iconLeft="mdi:plus" class="p-2">
            </app-button>
        </ng-template>

        <ng-template #userTmpl let-item>
            <div class="flex items-center gap-4">
                <div class="relative w-10 h-10">
                    <div
                        class="absolute inset-0 bg-primary/10 rounded-xl rotate-6 group-hover:rotate-12 transition-transform">
                    </div>
                    <div
                        class="w-full h-full flex items-center justify-center font-black text-[11px] text-primary bg-surface border border-primary/20 rounded-xl relative">
                        {{ getUserInitials(item.fullName) }}
                    </div>
                </div>
                <div class="flex flex-col">
                    <span class="text-foreground font-black tracking-tight leading-none text-[13px]">{{ item.fullName
                        }}</span>
                </div>
            </div>
        </ng-template>

        <ng-template #emailTmpl let-item>
            <div class="flex flex-col">
                <span class="text-[12px] font-bold text-foreground/60 leading-none">{{ item.email }}</span>
            </div>
        </ng-template>

        <ng-template #permsTmpl let-item>
            <div class="flex items-center gap-2">
                <div
                    class="px-2 py-1 rounded-lg bg-foreground/[0.03] border border-foreground/[0.05] flex items-center gap-1.5">
                    <iconify-icon icon="solar:shield-keyhole-bold-duotone" width="12"
                        class="text-primary/60"></iconify-icon>
                    <span class="text-[10px] font-bold text-slate-800 dark:text-white/90/60">{{ item.permissionsCount
                        }}</span>
                </div>
                <span class="text-[9px] font-black uppercase tracking-tighter text-foreground/50">Acciones</span>
            </div>
        </ng-template>

        <ng-template #statusTmpl let-item>
            <div class="flex items-center gap-2">
                <div
                    [class]="'w-1.5 h-1.5 rounded-full ' + (item.isActive ? 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]' : 'bg-foreground/20')">
                </div>
                <span class="text-[10px] font-black uppercase tracking-widest"
                    [class]="item.isActive ? 'text-foreground' : 'text-foreground/60'">
                    {{ item.isActive ? 'Activo' : 'Suspendido' }}
                </span>
            </div>
        </ng-template>

        <ng-template #actions let-item>
            <div class="flex items-center justify-end gap-1">
                <!-- Reenviar Verificación -->
                <ng-container *appCanAccess="'staff:edit'">
                    <app-button *ngIf="canResendVerification() && !item.isEmailVerified" variant="glass" size="xs"
                        [square]="true" (btnClick)="onResendClick(item)" class="p-1" iconLeft="solar:letter-bold-duotone"
                        title="Reenviar Verificación" color="text-orange-500"
                        hover="hover:text-orange-600 hover:border-orange-500/30 hover:bg-orange-500/5">
                    </app-button>
                </ng-container>

                <app-button *appCanAccess="'staff:list'" variant="glass" size="xs" [square]="true" (btnClick)="viewDetails(item)" class="p-1"
                    iconLeft="solar:eye-bold-duotone" title="Ver Detalles" color="text-blue-500"
                    hover="hover:text-blue-600 hover:border-blue-500/30 hover:bg-blue-500/5">
                </app-button>
                <ng-container *appCanAccess="'staff:edit'">
                    <app-button variant="glass" size="xs" [square]="true" color="text-green-500" class="p-1"
                        [routerLink]="['/app/staff/edit', item.id]" iconLeft="solar:pen-new-square-linear"
                        title="Editar" hover="hover:text-green-600 hover:border-green-500/30 hover:bg-green-500/5">
                    </app-button>
                </ng-container>
                <ng-container *appCanAccess="'staff:delete'">
                    <app-button variant="glass" size="xs" [square]="true" (btnClick)="deleteStaff(item.id)" class="p-1"
                        iconLeft="solar:trash-bin-minimalistic-linear" title="Eliminar" color="text-red-500"
                        hover="hover:text-red-600 hover:border-red-500/30 hover:bg-red-500/5">
                    </app-button>
                </ng-container>
            </div>
        </ng-template>

    </app-data-table>

    <!-- ── Modal de Detalles Ultra Compacto ────────────────────────────────────── -->
    <app-modal [isOpen]="showDetails()" (isOpenChange)="showDetails.set($event)"
        [title]="selectedStaff() ? selectedStaff()!.fullName : ''" icon="solar:user-id-bold-duotone">

        <div class="space-y-5 py-2" *ngIf="selectedStaff() as item">
            <!-- ── 1. Identidad Operativa ── -->
            <div class="space-y-2">
                <p class="text-[9px] font-black uppercase tracking-widest text-primary/80 flex items-center gap-1">
                    <iconify-icon icon="solar:user-circle-bold-duotone" width="12"></iconify-icon>
                    Identidad Operativa
                </p>
                <div class="grid grid-cols-2 gap-3">
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Nombre
                            Completo</span>
                        <span class="text-xs font-bold text-foreground">{{ item.fullName }}</span>
                    </div>
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Correo
                            Acceso</span>
                        <span class="text-xs font-bold text-foreground">{{ item.email }}</span>
                    </div>
                </div>
            </div>

            <!-- ── 2. Seguridad y Estado de Acceso ── -->
            <div class="space-y-2">
                <p class="text-[9px] font-black uppercase tracking-widest text-primary/80 flex items-center gap-1">
                    <iconify-icon icon="solar:shield-check-bold-duotone" width="12"></iconify-icon>
                    Seguridad y Estado de Acceso
                </p>
                <div class="grid grid-cols-2 gap-3">
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Estado
                            de Cuenta</span>
                        <div class="flex items-center gap-1.5">
                            <iconify-icon [icon]="item.isActive ? 'solar:verified-check-bold' : 'solar:danger-bold'"
                                [class]="item.isActive ? 'text-emerald-500' : 'text-red-500'" width="12"></iconify-icon>
                            <span class="text-xs font-bold"
                                [class]="item.isActive ? 'text-emerald-500' : 'text-red-500'">{{ item.isActive ?
                                'Activo' : 'Suspendido' }}</span>
                        </div>
                    </div>
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Atributo
                            Clínico</span>
                        <div class="flex items-center gap-1.5">
                            <iconify-icon
                                [icon]="item.isOdontologist ? 'solar:users-group-two-rounded-bold-duotone' : 'solar:user-id-linear'"
                                [class]="item.isOdontologist ? 'text-blue-500' : 'text-foreground/50'"
                                width="12"></iconify-icon>
                            <span class="text-xs font-bold"
                                [class]="item.isOdontologist ? 'text-blue-500' : 'text-foreground/60'">{{
                                item.isOdontologist ? 'Médico / Odontólogo' : 'Administrativo' }}</span>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-3">
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Perfil
                            Operador</span>
                        <span class="text-xs font-bold text-foreground/70 flex items-center gap-1">
                            <iconify-icon icon="solar:user-id-bold-duotone" class="text-primary text-xs"></iconify-icon>
                            Miembro Equipo
                        </span>
                    </div>
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Registrado
                            el</span>
                        <span class="text-xs font-bold text-foreground/70">{{ item.createdAt ? (item.createdAt |
                            date:'dd MMM, yyyy') : 'Precargado' }}</span>
                    </div>
                </div>
            </div>

            <!-- ── 3. Permisos de Negocio ── -->
            <div class="space-y-2">
                <p class="text-[9px] font-black uppercase tracking-widest text-primary/80 flex items-center gap-1">
                    <iconify-icon icon="solar:shield-keyhole-bold-duotone" width="12"></iconify-icon>
                    Permisos del Negocio
                </p>

                <div class="grid grid-cols-1 gap-2 max-h-[200px] overflow-y-auto pr-1">
                    <div *ngFor="let mod of getModulePermissions(item)"
                        class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-2">
                        <div class="flex items-center gap-2">
                            <iconify-icon icon="solar:folder-with-files-bold-duotone"
                                class="text-primary text-sm"></iconify-icon>
                            <span
                                class="text-[10px] font-bold text-slate-800 dark:text-white/90 uppercase tracking-wider">{{
                                mod.module
                                }}</span>
                        </div>
                        <div class="flex flex-wrap gap-1.5">
                            <div *ngFor="let act of mod.actions"
                                class="px-2 py-1 bg-primary/5 border border-primary/10 rounded-md flex items-center gap-1">
                                <iconify-icon icon="solar:check-circle-bold"
                                    class="text-primary text-[10px]"></iconify-icon>
                                <span class="text-[8px] font-bold text-foreground/80 uppercase">{{ act }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!getModulePermissions(item).length" class="text-xs text-foreground/60 italic">Sin
                        permisos de módulo específicos en este negocio</div>
                </div>
            </div>
        </div>

        <div actions class="flex justify-end items-center gap-3 w-full">
            <app-button *appCanAccess="'staff:edit'" variant="glass" size="xs" [routerLink]="['/app/staff/edit', selectedStaff()?.id]"
                color="text-blue-500" iconLeft="solar:pen-new-square-bold" (btnClick)="showDetails.set(false)"
                class="text-[10px] font-black uppercase">
                Editar Colaborador
            </app-button>
            <app-button variant="primary" size="xs" (btnClick)="showDetails.set(false)"
                iconLeft="solar:close-circle-bold">
                Cerrar
            </app-button>
        </div>
    </app-modal>
</div>

<!-- ── Diálogo de Confirmación para Reenvío ── -->
<app-confirm-dialog [(visible)]="showResendConfirm" title="Reenviar Verificación"
    [message]="'¿Estás seguro de que deseas reenviar el correo de activación a ' + (userToResend()?.fullName || 'este colaborador') + '?'"
    (confirm)="confirmResend()" icon="solar:letter-bold-duotone" confirmText="Reenviar Correo" cancelText="Cancelar"
    [loading]="isResending()">
</app-confirm-dialog>